import { render, staticRenderFns } from "./GroupsMenu.vue?vue&type=template&id=53a97b3e"
import script from "./GroupsMenu.vue?vue&type=script&lang=js"
export * from "./GroupsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports